import { render } from "./DefaultComponent.vue?vue&type=template&id=0f71213e"
import script from "./DefaultComponent.vue?vue&type=script&lang=js"
export * from "./DefaultComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__